<ng-container>
	<dodo-base-header></dodo-base-header>
	<div class="container">
		<div class="payment-header">Payment</div>
	</div>

	<div >
		<div class="container">
			
			
			<h3 *ngIf="error == false">
				Dear Customer, Please complete your secure payment below and let the Sales Representative know when you are done.
			</h3>
			<h3 *ngIf="error == true">
				{{errorMessage}}
			</h3>
		</div>

		<div class="ipsi" *ngIf="error == false">
		<div class="container-ipsi">
			<div class="delay-notice">
				<div> 
					<img class="creditImage" src="/assets/img/icons/icon-creditCard.png" />
					<span class="creditText">Credit Card</span>
				</div>
				<div>
					<img src="/assets/img/icons/lock.svg" />
					Secure credit card payment
				</div>
			</div>
			<div id="ipsi-container" [ngClass]="{'virtual-keyboard': _virtualKeyboardIframe}">
				
			</div>
			<div class="overlay" *ngIf="busy">
				<mat-spinner [color]="'accent'" [diameter]="40"></mat-spinner>
			</div>
		</div>
	    </div>
		<div class="pay-button" *ngIf="error == false">
			<div class="action">
				<dodo-raised-button
					[class.disabled]="false"
					id="paynow"
					color="accent"
					[disabled]="false"
					(clicked)="submitIpsiFrame()"
				>
					<img class="lock" src="/assets/img/icons/Lock-white.svg" />
					<span>PAY NOW</span>
				</dodo-raised-button>
			</div>
		</div>

		<div class="pay-button">
			<div class="action-back">
				<dodo-raised-button
					[class.disabled]="false"
					id="back"
					color="accent"
					[disabled]="false"
					(clicked)="backToReference()"
				>
					BACK
				</dodo-raised-button>
			</div>
		</div>
	</div>
</ng-container>
	